export enum AcknowledgementPage {
  PrivacyPolicy = 'privacy-policy',
  TermsAndConditions = 'terms-and-conditions',
}

export enum AcknowledgementState {
  showAcknowledgementModal = 'showAcknowledgementModal',
}
